/************
 Swipers
 ************/

// thumbnails mobile
let productV21ThumbnailImages = new Swiper("#productV21ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV21ThumbnailsNext',
        prevEl: '#productV21ThumbnailsPrev',
    },
});

// play video in the currently active slide (videos are muted + loop, so we never pause)
function playActiveSlideVideoV21(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector("video");
    if (!video) {
        return;
    }
    video.play();
}

// main swiper
let productV21Images = new Swiper("#productV21Swiper", {
    navigation: {
        nextEl: '#productV21Swiper .productV21SwiperNext',
        prevEl: '#productV21Swiper .productV21SwiperPrev',
    },
    loop: true,
    thumbs: {
        swiper: productV21ThumbnailImages
    },
    on: {
        init: function () {
            playActiveSlideVideoV21(this);
        },
        slideChange: function () {
            playActiveSlideVideoV21(this);
        }
    }
});

// gallery desktop
document.querySelectorAll(".productV21GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV21Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV21Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();
        
        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
        } else {
            popup.querySelector("video").play();
        }
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV21ReviewRaters")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV21() {
    // There are 3 senarios to determine the active variant
    // 1. Has only a default variant
    // 2. the color/background swatch
    // 3. the basic dropdown

    // check for an active color swatch
    if (product.variants.length === 1) {
        activeVariant = product.variants[0];
    } else if (document.querySelector(".productV21FormGroup.active")) {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector(".productV21FormGroupFlexColor:checked").value)
        })[0];
    } else {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector("#productV21FormVariants").value)
        })[0];
    }

    // find variant image by matching filename (media.id and featured_image.id differ in shopify's media model)
    if (activeVariant.featured_image) {
        const variantFilename = activeVariant.featured_image.src.split("/").pop().split("?")[0];
        const variantImage = Array.from(document.querySelectorAll(".productV21SwiperSlide")).find(slide => {
            const img = slide.querySelector("img");
            return img && img.src.split("/").pop().split("?")[0] === variantFilename;
        });
        if (variantImage) {
            productV21Images.slideTo(getElIndex(variantImage));
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // default quantity and discount
    let quantity = 1;
    let discount = 0;


    // compute price and compare at price
    let total = activeVariant.price * quantity - discount;
    let compareAtTotal = activeVariant.compare_at_price * quantity;

    // check for add on
    if (document.querySelector(".productV21UpsellTop:checked")) {
        total += parseInt(document.querySelector(".productV21UpsellTop:checked").dataset.price);
        let compare = parseInt(document.querySelector(".productV21UpsellTop:checked").dataset.compare) || 0
        if (compare < parseInt(document.querySelector(".productV21UpsellTop:checked").dataset.price)) {
            compare = parseInt(document.querySelector(".productV21UpsellTop:checked").dataset.price)
        }

        compareAtTotal += compare;
    }

    // calculate savings
    let savings = compareAtTotal - total;
    let savingsPercent = Math.round((savings / compareAtTotal) * 100);

    // update display
    if (total < compareAtTotal) {
        document.querySelector("#productV21PriceCompare").textContent = price(compareAtTotal, true);
        document.querySelector("#productV21PriceActual").textContent = `${price(total, true)}`;
        document.querySelector("#productV21PriceSavings").textContent = `SAVE 40 %`;
        document.querySelector("#productV21PriceSavings").classList.add('active');

    } else {
        document.querySelector("#productV21PriceCompare").textContent = "";
        document.querySelector("#productV21PriceActual").textContent = price(total, true);
        document.querySelector("#productV21PriceSavings").classList.remove('active');
    }


    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV21ATC").classList.remove("oos");
        document.querySelector("#productV21ATC").textContent = `Add To Cart`;
    } else {
        document.querySelector("#productV21ATC").classList.add("oos");
        document.querySelector("#productV21ATC").textContent = "Sold Out — Notify Me When Available";
    }

    // keep the sticky bar in step with the button state
    updateStickyBar();
}

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV21FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.querySelector(".productV21FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV21();
    });
});

// variant dropdown support on change
document.querySelector("#productV21FormVariants")?.addEventListener("change", updateProductV21);


/****************
 *  Quantity
 *************/

let quantity = 1;

// minus
document.querySelector("#productV21QuantityMinus")?.addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productV21QuantityValue").textContent = quantity;
});

// plus
document.querySelector("#productV21QuantityPlus")?.addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productV21QuantityValue").textContent = quantity;
});


/**************
 ORDERS REMAINING
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    document.querySelector('#productV21ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);
    document.querySelector('#productV21ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
}


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV21ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");


    // create form data
    let formData = {
        items: []
    };

    // check for add on
    let discountKit = "";
    if (document.querySelector(".productV21UpsellTop:checked")) {
        discountKit = 'tens-pads'
        formData.items.push({
            quantity: 1,
            id: parseInt(document.querySelector(".productV21UpsellTop:checked").dataset.id),
            properties: {
                "_discount_kit": discountKit
            }
        })
    }

    // normal product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
        properties: {
            "_discount_kit": discountKit
        }
    });


    // add productV21
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV21ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV21AddonCheckboxInput").checked) {
            document.querySelector("#productV21AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV21ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Upsell
 ***************/
document.querySelector('.productV21UpsellTop').addEventListener('change', function () {
    // dropdown
    document.querySelector(".productV21Upsell").classList.toggle("active");

    updateProductV21(true)
})


/**************
 Shipping Time
 ***************/

// show shipping tomorrow
let date = new Date();
date.setDate(date.getDate() + 1);
date = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
document.querySelector('#productV21ShippingDateTxt').innerHTML = `Ships <strong>Tomorrow, ${date}</strong>`;


/**************
 Sticky ATC
 ***************/

// ignore if noSticky class is present (the sticky bar replaces this)
if (!document.querySelector("#productV21ATC").classList.contains("noSticky")) {
    const stickyAtcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                document.querySelector("#productV21ATC").classList.remove("sticky");
            } else {
                document.querySelector("#productV21ATC").classList.add("sticky");
            }
        });
    }, {
        rootMargin: "-100px 0px 0px 0px"
    })

    stickyAtcObserver.observe(document.querySelector("#productV21Content"));
}

/**************
 Sticky ATC Bar
 ***************/

// mirror the buy button state into the bar
// queries its own elements since updateProductV21 can run before this block
function updateStickyBar() {
    const stickyBar = document.querySelector("#productV21Sticky");

    // only rendered when the "Use Sticky ATC Bar" setting is on
    if (!stickyBar) {
        return;
    }

    // the bar's button is a copy of the real one, right down to the sold out label
    const atc = document.querySelector("#productV21ATC");
    const stickyATC = stickyBar.querySelector("#productV21StickyATC");
    stickyATC.textContent = atc.textContent;
    stickyATC.classList.toggle("oos", atc.classList.contains("oos"));
}

const stickyBar = document.querySelector("#productV21Sticky");

if (stickyBar) {
    const atc = document.querySelector("#productV21ATC");

    // the bar's button is a proxy for the real one, popups and cart logic included
    stickyBar.querySelector("#productV21StickyATC").addEventListener("click", function () {
        atc.click();
    });

    // the real button owns the add to cart lifecycle, so mirror its spinner instead of running our own
    const stickyATCLoadingObserver = new MutationObserver(function () {
        stickyBar.querySelector("#productV21StickyATC").classList.toggle("loading", atc.classList.contains("loading"));
    });
    stickyATCLoadingObserver.observe(atc, {attributeFilter: ["class"]});

    // reveal the bar once the real button is scrolled past, not while it's still below the fold; the 80px inset stops edge flicker
    const stickyBarObserver = new IntersectionObserver(function (entries) {
        const scrolledPast = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        stickyBar.classList.toggle("active", scrolledPast);
    }, {
        threshold: 0,
        rootMargin: "0px 0px -80px 0px"
    });
    stickyBarObserver.observe(atc);

    // sync the initial paint with the real button's text
    updateStickyBar();
}

// event listeners for dropdown items
document.querySelectorAll(`.productV21DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

